import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../store/Home';
import Kanban from './Controls/Kanban/Kanban';
import KanbanExperimental from './Controls/ExperimentalKanban/KanbanExperimental';
import AuthStore from './Auth/AuthStore';
import { observer } from 'mobx-react';

const Board = observer(class Board extends Component {
    constructor() {
        super();
        this.state = {
        };
    };

    componentDidMount() {
    };

    render() {
        return (
            <>
                {true /*&& !AuthStore.getUseExperimentalMode */&& <Kanban />}
                {false && AuthStore.getUseExperimentalMode && <KanbanExperimental />}
            </>
        );
    }
})

export default Board;

/*export default connect(
    state => state.board,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Board);*/

